var map = {
	"./badminton.png": 353,
	"./baseball.png": 354,
	"./basketball.png": 355,
	"./binary.png": 384,
	"./boxing.png": 356,
	"./cardicon.png": 357,
	"./casino.png": 358,
	"./crash_games.png": 385,
	"./cricket.png": 386,
	"./cs.png": 359,
	"./dota.png": 360,
	"./efighting.png": 361,
	"./election.png": 387,
	"./fifa.png": 362,
	"./formula.png": 363,
	"./golf.png": 364,
	"./greyhound-racing.png": 388,
	"./greyhound.png": 365,
	"./horse-racing.png": 389,
	"./horse.png": 366,
	"./inplay.png": 390,
	"./kabaddi.jpg": 860,
	"./kabaddi.png": 367,
	"./live-card.png": 391,
	"./live-casino.png": 392,
	"./lottery.png": 393,
	"./more.png": 394,
	"./premium-notebook.png": 395,
	"./raceicon.png": 396,
	"./rugby.png": 368,
	"./slot-games.png": 397,
	"./sloticon.png": 369,
	"./sloticon1.png": 398,
	"./soccer.png": 399,
	"./sportsbook.png": 400,
	"./table-tennis.png": 370,
	"./tennis.png": 401,
	"./virtual.png": 371,
	"./voleyball.png": 372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2031;